import { shallowRef } from 'vue'

export const createStartupNavigationIntent = () => {
  const isClaimed = shallowRef(false)

  const claim = () => {
    isClaimed.value = true
  }

  return { isClaimed, claim }
}

export const shouldNavigateToStartPage = (
  isWeb: boolean,
  hasSession: boolean,
  startupNavigationClaimed: boolean,
) => !isWeb && hasSession && !startupNavigationClaimed
